'use client';

import { useEffect, useRef } from 'react';
import { dataLayerPush } from '@libs/analytics';

type EventTracking = {
    [key: string]: unknown;
};

export function Observer(trackingData: EventTracking) {
    const elementRef = useRef<HTMLDivElement>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        observerRef.current = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && trackingData) {
                dataLayerPush(trackingData);
            }
        });
    }, [trackingData]);

    useEffect(() => {
        observerRef?.current?.observe(
            elementRef.current || new HTMLDivElement()
        );
        return () => {
            observerRef?.current?.disconnect();
        };
    }, [elementRef]);

    return <div ref={elementRef} />;
}
